module.exports = __webpack_public_path__ + "static/media/image-2.f165d578.avif";